/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Price_Commission_BodyInputs */

const es_landing_price_commission_body = /** @type {(inputs: Landing_Price_Commission_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El precio del anuncio es exactamente lo que paga tu cliente, sin recargos por encima. Nuestra comisión sale de ese importe, siempre a la vista — nunca de tu bolsillo.`)
};

const gl_landing_price_commission_body = /** @type {(inputs: Landing_Price_Commission_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O prezo do anuncio é exactamente o que paga o teu cliente, sen recargos por riba. A nosa comisión sae dese importe, sempre á vista — nunca do teu peto.`)
};

const en_landing_price_commission_body = /** @type {(inputs: Landing_Price_Commission_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The listing price is exactly what your guest pays, with no mark-ups on top. Our commission comes out of that amount, always visible — never from your pocket.`)
};

/**
* | output |
* | --- |
* | "The listing price is exactly what your guest pays, with no mark-ups on top. Our commission comes out of that amount, always visible — never from your pocket." |
*
* @param {Landing_Price_Commission_BodyInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_price_commission_body = /** @type {((inputs?: Landing_Price_Commission_BodyInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Price_Commission_BodyInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_price_commission_body(inputs)
	if (locale === "en") return en_landing_price_commission_body(inputs)
	return es_landing_price_commission_body(inputs)
});